/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="95.57" height="78.95" viewBox="0 0 95.57 78.95" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <path d="M77.29,55.4a8.37,8.37,0,1,0,8.36,8.37A8.36,8.36,0,0,0,77.29,55.4Zm0,2.5a5.87,5.87,0,1,1-5.86,5.87A5.86,5.86,0,0,1,77.29,57.9Z" transform="translate(-29.5 -38)" fill="#ffb81c"/><path d="M83,100.56a3.21,3.21,0,1,0-3.21,3.21A3.21,3.21,0,0,0,83,100.56" transform="translate(-29.5 -38)" fill="#ffb81c" fillRule="evenodd"/><path d="M111,41a1.25,1.25,0,0,1,1.24,1.13V115.7a1.24,1.24,0,0,1-1.12,1.24H43.61a1.24,1.24,0,0,1-1.24-1.12V62.76a1.25,1.25,0,0,1,2.49-.13v51.82h64.88v-71H99.33v9.82a1.26,1.26,0,0,1-1.12,1.25h-.13a1.25,1.25,0,0,1-1.24-1.12V42.2A1.26,1.26,0,0,1,98,41h13Z" transform="translate(-29.5 -38)" fill="#0e497b"/><path d="M76.58,38.22a1.23,1.23,0,0,1,1.29-.07l.12.07,46.54,31.87a1.24,1.24,0,0,1,.33,1.73,1.26,1.26,0,0,1-1.63.4l-.11-.07L77.29,40.76,31.46,72.15a1.26,1.26,0,0,1-1.66-.22l-.08-.11a1.24,1.24,0,0,1,.22-1.65l.1-.08Z" transform="translate(-29.5 -38)" fill="#0e497b"/><path d="M65,97.1c0-17,24-17.16,24.51-.51v19H87V97.1c0-13.69-19.13-13.82-19.51-.41v18.94H65Z" transform="translate(-29.5 -38)" fill="#0e497b"/>
</svg>

    );
  }
}

Icon.displayName = 'HouseIcon';

export default Icon;
